import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import Textfield from "../../common/Textfield";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../../actions";

const AddPractiseContent = ({
  email,
  emailChangeHandler,
  emailError,
  practiseName,
  setPractiseName,
  ownerName,
  setOwnerName,
  specialtyId,
  setSpecialtyId,
  specialtyError,
  setSpecialtyError,
}) => {
  const [specialties, setSpecialties] = useState([]);
  const [specialtyLoadError, setSpecialtyLoadError] = useState("");

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const token = Cookies.get("token");
        const config = {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        };

        const response = await axios.get(`${BASE_URL}/specialty/list`, config);

        if (!response?.data?.ok) {
          throw new Error(
            response?.data?.msg || "Unable to load specialties"
          );
        }

        setSpecialties(response?.data?.specialties || []);
        setSpecialtyLoadError("");
      } catch (err) {
        setSpecialtyLoadError(
          err.response?.data?.msg || err.message || "Unable to load specialties"
        );
      }
    };

    fetchSpecialties();
  }, []);

  return (
    <Stack gap="16px">
      <Textfield
        value={practiseName}
        onChange={(e) => setPractiseName(e.target.value)}
        label="Practice name"
        placeholder="Health care experts"
        variant="outlined"
        name="practise_name"
      />
      <Textfield
        value={ownerName}
        onChange={(e) => setOwnerName(e.target.value)}
        label="Owner's Name"
        placeholder="John Doe"
        variant="outlined"
        name="owner_name"
      />
      <Textfield
        value={email}
        onChange={emailChangeHandler}
        label="Owner's Email"
        placeholder="example@gmail.com"
        variant="outlined"
        name="email"
        errorContent={emailError && "Enter valid email"}
        helperText={emailError && "Enter valid email"}
      />
      <FormControl
        fullWidth
        error={(!specialtyId && specialtyError) || Boolean(specialtyLoadError)}
      >
        <InputLabel id="add-practice-specialty-select-label">
          Select specialty
        </InputLabel>
        <Select
          labelId="add-practice-specialty-select-label"
          id="add-practice-specialty-select"
          value={specialtyId}
          label="Select specialty"
          onChange={(e) => {
            setSpecialtyId(e.target.value);
            if (setSpecialtyError) {
              setSpecialtyError(false);
            }
          }}
        >
          {specialties.map((specialty) => (
            <MenuItem key={specialty.id} value={specialty.id}>
              {specialty.name}
            </MenuItem>
          ))}
        </Select>
        {!specialtyId && specialtyError && (
          <FormHelperText>Please select a specialty!</FormHelperText>
        )}
        {specialtyLoadError && (
          <FormHelperText>{specialtyLoadError}</FormHelperText>
        )}
      </FormControl>

      <Typography variant="body2" color="secondary" fontSize="1.5rem">
        Password will be automatically generated and sent to your email address.
      </Typography>
    </Stack>
  );
};

export default AddPractiseContent;
